import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { WhiteSpace, List, Toast } from 'antd-mobile';
import { Icon } from 'antd';
import { createBrowserHistory } from "history";
import './style.less';

const history = createBrowserHistory();
let firstShow = true;
export default class IntegralSyfw extends Component {
    constructor(props) {
        super(props);
        this.state =
            {
                publicId: this.props.match.params.publicId,
                hList: [],
                total: 0,
            }
    }
    componentDidMount() {
        services.GetUnionListpublic(this.state.publicId, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                firstShow = false;
                if (!data.result.isdestination) {
                    services.GetUnionListpublic2('').then((data2 => {
                        if (data2.status === 0) {
                            this.setState({ total: data2.result.length, hList: data2.result });
                        } else {
                            Toast.offline(data.message);
                        }
                    }));

                } else {
                    this.setState({ total: data.result.children.length, hList: data.result.children });
                }
            } else {
                Toast.offline(data.message);
            }
        });
    }
    render() {
        const { hList, total } = this.state;
        return <div className="integral">
            <CommonlyHeadMembers barname='使用范围' />
            <div className="linkList linkList2">
                <List>
                    {
                        hList.length <= 0 ? '' :
                            hList.map((data, index) => (
                                <List.Item key={index} arrow="horizontal"
                                    onClick={() => {
                                        history.push(`/hospital/details/${data.unionCode}`);
                                        history.go();
                                    }}
                                >
                                    <Icon type="medicine-box" style={{ fontSize: '16px', color: '#32a128', marginRight: '10px' }} />{data.unionName}
                                </List.Item>
                            ))
                    }
                </List>
                {total === 0 && firstShow === false ?
                    <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                        <p>暂无数据</p>
                    </div>
                    : ''}
                <WhiteSpace />
            </div>
        </div >;
    }
}